var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"end-node"},[_c('div',{staticClass:"end-node-circle"}),_c('div',{staticClass:"end-node-text"},[_vm._v("流程结束")])])}]

export { render, staticRenderFns }